var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCreateExternalRecord = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#563BCE",
    d: "M21.75 12c0 5.385-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12 6.615 2.25 12 2.25s9.75 4.365 9.75 9.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    d: "M17.25 15.938a.263.263 0 0 0-.262-.263h-.6v-.6a.263.263 0 0 0-.526 0v.6h-.6a.26.26 0 0 0-.262.26v.002c0 .146.118.263.262.263h.6v.6c0 .144.117.261.26.262h.003a.263.263 0 0 0 .262-.262v-.6h.6a.263.263 0 0 0 .263-.262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M18.375 15.938a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0m-2.25 1.687a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.375",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBFA",
    fillRule: "evenodd",
    d: "M10.114 9.16a.75.75 0 0 0 .193-.502V7.125a.75.75 0 0 0-.75-.75H6.75a.75.75 0 0 0-.75.75v1.533c0 .414.336.75.75.75h2.6l.012.018 1.043 1.541a1.77 1.77 0 0 0-.349 1.059c0 .837.578 1.538 1.353 1.722v1.22h-.992a.75.75 0 0 0-.75.75v1.532c0 .414.335.75.75.75h1.958a.375.375 0 0 0 0-.75h-1.958v-1.533h1.164q.022.003.044.003h.75a.375.375 0 0 0 0-.75v-.003h-.195v-1.21a1.77 1.77 0 0 0 1.39-1.731c0-.398-.13-.764-.35-1.06l.006-.007 1.015-1.501a.4.4 0 0 0 .03-.05h2.604a.75.75 0 0 0 .75-.75V7.125a.75.75 0 0 0-.75-.75h-2.807a.75.75 0 0 0-.75.75v1.533c0 .193.073.37.193.502l-.88 1.3a1.74 1.74 0 0 0-1.638 0l-.88-1.3Zm-.557-.502H6.75V7.125h2.807zm2.256 2.349c-.551 0-1.007.451-1.007 1.019s.456 1.019 1.007 1.019 1.007-.452 1.007-1.02c0-.567-.456-1.018-1.007-1.018m5.062-2.35h-2.807V7.126h2.807v1.533Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCreateExternalRecord);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/create-external-record.3ce8e6ee.svg";